import { styled } from "@mui/material";
import BallotIcon from "./BallotIcon";
import PageSection from "controls/global/page-section";
import React, { useEffect } from "react";
import ScrollToTopArrow from "controls/global/scroll-to-top-arrow";
import useTitle from "utils/custom-hooks/useTitle";
import {
  Box,
  Grid,
  Typography ,
} from "@mui/material";
import { Link } from "react-router-dom";
import {
  colors,
  fontFamily,
  fontSize,
  fontWeight,
  margin,
  padding,
} from "theme/defaultStyle";
import { useProfileSettingsCache } from "utils/context/ProfileSettingsContext";

const StyledBoxContainer = styled(Box)({
  position: "relative",
});

const HeadingContainer = styled(Box)({
  alignItems: "center",
  display: "flex",
  marginBottom: margin.xsmall,
});

const ListPrimaryHeading = styled(Typography)({
  color: colors.blue05,
  fontFamily: fontFamily.primary,
  fontSize: fontSize.xlarge0,
  fontWeight: fontWeight.bold2,
  paddingLeft: padding.small2,
});

const ListSecondaryHeading = styled(Typography)({
  color: colors.grey11,
  fontFamily: fontFamily.primary,
  fontSize: fontSize.large,
  fontWeight: fontWeight.normal1,
  paddingLeft: padding.small2,
});

const StewartResources = () => {
  useTitle("Stewart Connect - Resources");
  const [{ profileSettings }, { getProfileSettings }] = useProfileSettingsCache();

  useEffect(() => {
    const handleLinkClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const linkElement = target.closest("a");

      if (linkElement) {
        const href = linkElement.getAttribute("href");
        const hasPermission = profileSettings?.userPermissionItemTypes.includes(href);
        if (href?.startsWith("http")) {
          return;
        }
        if (!hasPermission) {
          event.preventDefault();
          getProfileSettings();
        }
      }
    };

    document.addEventListener("click", handleLinkClick);

    return () => {
      document.removeEventListener("click", handleLinkClick);
    };
  }, [getProfileSettings]);

  return (
    <StyledBoxContainer>
      <PageSection
        contentAlignment="below-header"
        icon={<BallotIcon />}
        title="Stewart Resources"
      >
        <Grid container>
          <Grid
            item
            xs={12}
          >
            <a
              href="https://www.stewart.com/academy"
              target="_blank"
              rel="noopener noreferrer"
            >
              <HeadingContainer>
                <ListPrimaryHeading>Stewart Academy</ListPrimaryHeading>
              </HeadingContainer>
            </a>
            <ListSecondaryHeading>
              Stewart Academy is a training site hosted by 360Learning that helps title agents build knowledge in the
              title insurance industry through short, practical learning modules. The catalog covers core areas such as
              title and escrow fundamentals, compliance and regulatory topics, information security, and industry trends
              (including economic conditions), and it also offers on-demand, state-specific courses that may be approved
              for CE/CLE credit in select states.
            </ListSecondaryHeading>
          </Grid>
          <Grid
            item
            xs={12}
          >
            <Link to="/stewartpreferred">
              <HeadingContainer>
                <ListPrimaryHeading>Stewart Preferred</ListPrimaryHeading>
              </HeadingContainer>
            </Link>
            <ListSecondaryHeading>
              Our Stewart Preferred program provides Stewart Trusted Providers products and services at nationally
              negotiated rates from a variety of vendors. From business solutions such as background checks and market
              intelligence, to check stock and office supplies, to digital solutions such as DocuSign and NotaryCam,
              we&apos;ve got programs to help your agency save.
            </ListSecondaryHeading>
          </Grid>
          <Grid
            item
            xs={12}
          >
            <a
              href="https://www.virtualunderwriter.com/en.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <HeadingContainer>
                <ListPrimaryHeading>Virtual Underwriter</ListPrimaryHeading>
              </HeadingContainer>
            </a>
            <ListSecondaryHeading>
              With Virtual Underwriter, you have access to information needed to underwrite a real estate transaction,
              24 hours a day, seven days a week.
            </ListSecondaryHeading>
          </Grid>
        </Grid>
      </PageSection>
      <ScrollToTopArrow />
    </StyledBoxContainer>
  );
};

export default StewartResources;
